export { whiteSpaceValidation } from './whiteSpace';

export const PASSWORD_RGX = /^[A-z0-9А-я!@#$%^&*(){}_+\-=|\\/.,?><`~:;]+$/g;

export const USER_PASSWORD_HINT = 'Не менее 8 символов: латиница (a–z, A–Z), минимум 1 цифра и минимум 1 спецсимвол';

export const USER_PASSWORD_RGX = /^(?=.*\d)(?=.*[!@#$%^&*(){}_+\-=|\\/.,?><`~:;[\]'"«»„“—–№§©®™€£¥¢°±×÷•])[a-zA-Z0-9!@#$%^&*(){}_+\-=|\\/.,?><`~:;[\]'"«»„“—–№§©®™€£¥¢°±×÷•]{8,}$/;
